import React from 'react';

import {
    yMapHintContainer, yMapHintDescription, yMapHintInfo, yMapHintTitle
} from '@search/ymap/src/hint';
import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import { formatPrice } from '@search/helpers/src/formatPrice';
import { formatAreaRange } from '@search/helpers/src/formatArea';
import { Currency } from '@search/filter-enums/enums/Currency';

import { OfferYMapPlacemarkTooltip } from '../placemark/Placemark';
import { OfferYMapLandMultiProps } from './LandMultiProps';

export function OfferYMapLandMulti({
    id,
    minPrice,
    minArea,
    maxArea,
    count,
    coordinates,
    url,
    isActive,
    onClick,
    targetBlank = true,
    isHighlighted,
    zIndexes,
    dataTest
}: OfferYMapLandMultiProps) {
    const realtyStr = declensionByNumber(count, [ 'участок', 'участка', 'участков' ]);

    const hintLayout = yMapHintContainer(`
        ${yMapHintInfo(`
            ${yMapHintTitle(`${count} ${realtyStr}`)}
            ${minArea && maxArea ? yMapHintDescription(formatAreaRange({ minArea, maxArea })) : ''}
        `)}
    `);

    const minPriceStr = formatPrice({
        value: minPrice.rubPrice ?? minPrice.value,
        currency: minPrice.rubPrice ? Currency.RUB : minPrice.currency,
        inWords: true
    });

    return (<OfferYMapPlacemarkTooltip
        id={id}
        url={url}
        isActive={isActive}
        onClick={onClick}
        dataTest={dataTest}
        targetBlank={targetBlank}
        title={`от ${minPriceStr}`}
        total={String(count)}
        coordinates={{ y: coordinates.latitude, x: coordinates.longitude }}
        hintLayout={hintLayout}
        isHighlighted={isHighlighted}
        zIndexes={zIndexes}
    />);
}
